import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickZonelessModule } from '@core/directives/zoneless/click/click-zoneless.module';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { BtnActionComponent } from './btn-action/btn-action.component';
import { BtnFilterComponent } from './btn-filter/btn-filter.component';
import { BtnFlatComponent } from './btn-flat/btn-flat.component';
import { BtnOutlineComponent } from './btn-outline/btn-outline.component';
import { BtnSolidComponent } from './btn-solid/btn-solid.component';

@NgModule({
  declarations: [BtnFlatComponent, BtnOutlineComponent, BtnSolidComponent, BtnActionComponent, BtnFilterComponent],
  exports: [BtnSolidComponent, BtnOutlineComponent, BtnFlatComponent, BtnActionComponent, BtnFilterComponent],
  imports: [CommonModule, TranslateUiModule, ClickZonelessModule]
})
export class ButtonsModule {}
